import * as React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { PrimaryButton } from '@fluentui/react';
import { formStyles } from 'styles/formStyles';
import { authSelector } from 'store/auth/selector';
import { Betreuer } from 'api/betreuer';
import { RolleLabel } from 'utils/labels';

interface BetreuerItemProps {
    betreuer: Betreuer;
    editBetreuer: () => void;
}

export const BetreuerItem: React.FC<BetreuerItemProps> = ({ betreuer, editBetreuer }) => {
    const auth = useSelector(authSelector);

    const renderEditButton = () => (
        <div>
            {auth.rolle === 'GF' && (
                <PrimaryButton
                    onClick={() => {
                        editBetreuer();
                    }}
                    text="Bearbeiten"
                />
            )}
        </div>
    );

    return (
        <div className={formStyles.listItem}>
            <div className={formStyles.topBlock}>
                <div>
                    <div className={classnames(formStyles.listTitle)}>{betreuer.kz + ' - ' + betreuer.name}</div>
                </div>
                {renderEditButton()}
            </div>
            <div className={formStyles.threeColumnsBlock}>
                <div className={formStyles.firstColumn}>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>Firma:</div>
                        <div className={formStyles.dataValue}>{betreuer.firma}</div>
                    </div>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>Rolle:</div>
                        <div className={formStyles.dataValue}>{RolleLabel[betreuer.rolle] || betreuer.rolle}</div>
                    </div>
                </div>
                <div className={formStyles.secondColumn}>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>Telefon:</div>
                        <div className={formStyles.dataValue}>{betreuer.telefon}</div>
                    </div>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>Mobil:</div>
                        <div className={formStyles.dataValue}>{betreuer.mobil}</div>
                    </div>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>E-Mail:</div>
                        <div className={formStyles.dataValue}>{betreuer.mail}</div>
                    </div>
                </div>
                <div className={formStyles.thirdColumn}>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>Land:</div>
                        <div className={formStyles.dataValue}>{betreuer.land}</div>
                    </div>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>PLZ:</div>
                        <div className={formStyles.dataValue}>{betreuer.plz}</div>
                    </div>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>Ort:</div>
                        <div className={formStyles.dataValue}>{betreuer.ort}</div>
                    </div>
                    <div className={formStyles.keyValueLine}>
                        <div className={formStyles.dataKey120}>Strasse:</div>
                        <div className={formStyles.dataValue}>{betreuer.strasse}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
